// removed by extract-text-webpack-plugin
module.exports = {"basic":"basic___iGI8O","query-types-select-wrapper":"query-types-select-wrapper___ZbDi3","select-wrapper":"select-wrapper___2VWSp","icon-call-wrapper":"icon-call-wrapper___2prM-"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/customer-service/contact-us.module.scss
// module id = 888
// module chunks = 0